import { types } from "../types/types";

const initialState = {
  cargada: false,
  items: [],
  loading: false,
  error: null,
};

export const observacionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.observacionesTraerStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.observacionesTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.observacionesTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        cargada: false,
      };
      case types.observacionesLimpiar:
        return {
          loading: false,
          items: [],
          cargada: false,
        };
        case types.observacionesInsertSuccess:
        return {
          loading: false,
          items: [action.payload, ...state.items],
          cargada: true,
        };
        case types.observacionesDeleted:
      return {
        ...state,
        cargada: true,
        items: state.items.filter(
          (item) => parseInt(item.idItem) !== parseInt(action.payload)
        ),
      };
    default:
      return state;
  }
};
